<!--<div id="lm-reports-search-wrapper" class="lm-reports-search-wrapper scrollable">-->
@if (parentDataGrid) {
  <div class="lm-reports-search-content"
    attr.data-automation-id="lm-reports-{{reportListId}}-search">
    <!-- BEGIN NAME SEARCH -->
    <ng-template *ngTemplateOutlet="reportTextSearch; context: {$implicit: this.textSearchFields['keyword']}"></ng-template>
    <!-- END NAME SEARCH -->
    <!-- BEGIN SWITCH -->
    <div class="lm-reports-owner-switch-wrapper field">
      @if (!isWFMStandaloneWebapp) {
          <div class="switch">
            <input type="checkbox" class="switch"
              id="lm-reports-{{reportListId}}-my-reports-switch" attr.data-automation-id="lm-reports-{{reportListId}}-my-reports-switch"
              name="lm-reports-my-reports-switch"
              [(ngModel)]="onlyMyReports"
              (change)="buildAndApplyFilter()">
              <label soho-label lm-label class="audible" for="lm-reports-{{reportListId}}-my-reports-switch" class="label" checked>{{onlyMyReportsLabel}}</label>
            </div>
      }
      </div>
      <div class="lm-reports-favorite-switch-wrapper field">
        <div class="switch">
          <input type="checkbox" class="switch"
            id="lm-reports-{{reportListId}}-favorites-switch" attr.data-automation-id="lm-reports-{{reportListId}}-favorites-switch"
            name="lm-reports-favorites-switch"
            [(ngModel)]="onlyFavorites"
            (change)="buildAndApplyFilter()">
            <label soho-label lm-label class="audible" for="lm-reports-{{reportListId}}-favorites-switch" class="label" checked>{{onlyFavoritesLabel}}</label>
          </div>
        </div>
        <!-- END SWITCH -->
        <!-- BEGIN CHECKBOXES -->
        <div class="lm-modules-section">
          @for (module of moduleObjectArray; track module; let i = $index) {
            <div class="lm-reports-category-checkbox-wrapper">
              <a
                class="lm-collapsible-btn active"
                id="lm-collapsible-btn-{{reportListId}}-{{module.moduleId}}"
                role="presentation"
                soho-tooltip [content]="module.moduleName">
                <input soho-checkbox type="checkbox"
                  id="lm-reports-{{reportListId}}-category-{{module.moduleId}}" name="lm-reports-{{reportListId}}-category-{{module.moduleId}}"
                  class="lm-reports-header-checkbox"
                  [(ngModel)]="module.hasSelectedSubcategories"
                  [class.partial]="module.numSelectedSubcategories > 0 && module.numSelectedSubcategories < module.categoryArray.length"
                  (change)="categoryCheckboxOnChange($event, module.moduleName, i)">
                  <label soho-label lm-label class="audible" for="lm-reports-{{reportListId}}-category-{{module.moduleId}}" class="label"
                  attr.data-automation-id="lm-reports-{{reportListId}}-category-{{module.moduleId}}">{{module.moduleName}}</label>
                  <span class="lm-reports-chevron" (click)="toggleCollapsible($event, i)"
                    attr.data-automation-id="lm-reports-{{reportListId}}-toggle-{{module.moduleId}}">
                    @if (module.collapsed) {
                      <svg soho-icon icon="chevron-down"></svg>
                    }
                    @if (!module.collapsed) {
                      <svg soho-icon icon="chevron-up"></svg>
                    }
                  </span>
                </a>
                <div #categoryContent class="lm-category-checkboxes" [class.lm-collapsed]="module.collapsed">
                  @for (category of module.categoryArray; track category; let j = $index) {
                    <div class="category-checkbox"
                      soho-tooltip [content]="category.name">
                      <input soho-checkbox type="checkbox" class="checkbox"
                        id="lm-reports-{{reportListId}}-category-{{module.moduleId}}-{{category.id}}" name="lm-reports-{{reportListId}}-category-{{module.moduleId}}-{{category.id}}"
                        [(ngModel)]="category.isChecked"
                        (change)="subcategoryCheckboxOnChange($event, category.name, i, j)">
                        <label soho-label lm-label class="audible" for="lm-reports-{{reportListId}}-category-{{module.moduleId}}-{{category.id}}" class="label"
                        attr.data-automation-id="lm-reports-{{reportListId}}-category-{{module.moduleId}}-{{category.id}}">{{category.name}}</label>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <!-- END CHECKBOXES -->
            <!-- BEGIN ADVANCED SEARCH -->
            @if (!isWFMStandaloneWebapp) {
                <soho-expandable-area class="lm-hide-footer lm-reports-advanced-search">
                  <soho-expandable-header>
                    <div (click)="onExpandableAreaClicked($event)"
                      id="lm-reports-{{reportListId}}-advanced-search"
                      attr.data-automation-id="lm-reports-{{reportListId}}-advanced-search">
                      <span>{{advancedSearchTitle}}</span>
                      <svg soho-icon [icon]="buttonIcon" class="icon collapsible-header-icon"></svg>
                    </div>
                  </soho-expandable-header>
                  <soho-expandable-pane>
                    <!--      Commenting out Keyword search until it can work in tandem with the normal filter - see IDS issue 7713 -->
                    <!--     <span soho-searchfield-wrapper>-->
                    <!--        <input soho-searchfield-->
                    <!--            [placeholder]="keywordPlaceholder"-->
                    <!--            id="lm-reports-{{reportListId}}-keyword-search"-->
                    <!--            name="lm-reports-{{reportListId}}-keyword-search"-->
                    <!--            [(ngModel)]="keywordFieldValue"-->
                    <!--            (keyup)="triggerKeywordSearch()"-->
                    <!--            [clearable]="true"-->
                    <!--            (cleared)="triggerKeywordSearch()"-->
                    <!--        />-->
                  <!--      </span>-->
                  <ng-template *ngTemplateOutlet="reportTextSearch; context: {$implicit: this.textSearchFields['name']}"></ng-template>
                  <ng-template *ngTemplateOutlet="reportTextSearch; context: {$implicit: this.textSearchFields['busClass']}"></ng-template>
                  <ng-template *ngTemplateOutlet="reportTextSearch; context: {$implicit: this.textSearchFields['sharedWith']}"></ng-template>
                  <ng-template *ngTemplateOutlet="reportTextSearch; context: {$implicit: this.textSearchFields['owner']}"></ng-template>
                  <!-- BEGIN SWITCH -->
                  @if (!hideDeliveredReportsConfigFeature) {
                    <div class="lm-reports-owner-switch-wrapper field">
                      <div class="switch">
                        <input type="checkbox" class="switch"
                          id="lm-reports-{{reportListId}}-hide-delivered-reports-switch" attr.data-automation-id="lm-reports-{{reportListId}}-hide-delivered-reports-switch"
                          name="lm-reports-delivered-reports-switch"
                          [(ngModel)]="hideDelivered"
                          (change)="buildAndApplyFilter()">
                          <label soho-label lm-label class="audible" for="lm-reports-{{reportListId}}-hide-delivered-reports-switch" class="label" checked>{{hideDeliveredLabel}}</label>
                        </div>
                      </div>
                    }
                    <!-- END SWITCH -->
                  </soho-expandable-pane>
                </soho-expandable-area>
                <!-- END ADVANCED SEARCH -->
            }
          </div>
          } <!-- END SEARCH FORM -->

          <!-- Template for text search fields -->
          <ng-template #reportTextSearch let-field>
            <form (ngSubmit)="buildAndApplyFilter()" class="lm-searchfield-form">
            <span soho-searchfield-wrapper>
              <input soho-searchfield
                [placeholder]="field.placeholder"
                id="lm-reports-{{reportListId}}-{{field.name}}-search"
                attr.data-automation-id="lm-reports-{{reportListId}}-{{field.name}}-search"
                name="lm-reports-{{reportListId}}-{{field.name}}-search"
                enterkeyhint="search"
                [(ngModel)]="field.value"
                [ngModelOptions]="{standalone: true}"
                (keyup)="doTextSearch($event, field)"
                (keyup.delete)="buildAndApplyFilter()"
                [clearable]="true"
                (cleared)="clearTextSearch(field)"
                />
              </span>
            </form>
            </ng-template>